import { useEffect, useRef } from "react";
import AMapLoader from "@amap/amap-jsapi-loader";

import StringUtils from "../../../util/StringUtils";
import "./MapPosition.scss";
import { MapPositionWrapper } from "./MapPosition.styled";

interface MapPositionProps {
    lng: number;
    lat: number;
    zoom: number;
    status: string;
}

const MapPosition: React.FC<MapPositionProps> = (props)=> {
    // ref
    let aMapContainerRef = useRef(null as any);
    let aMapTypeRef = useRef(null as any);
    let amapRef = useRef(null as any);
    let locaContextRef = useRef({loca: null, pulseLinkLayer: null} as any);

    // functions
    let initializeMap = (dom: HTMLElement)=> {
        AMapLoader.load({
            "key": "0c3d07d8ebae700b5652bbfc2cf18fb0", 
            "version": "2.0",
            "plugins": [],
        }).then((AMap)=>{
            if (dom == null || aMapContainerRef.current == dom) {
                return;
            }

            let propsHasLngLat = props.lng != null && props.lat != null;
            const amap = new AMap.Map(dom, {
                pitchEnable: false,
                zoom: props.zoom,
                zooms:[5,20],
                pitch: 25,
                center: propsHasLngLat ? [props.lng, props.lat] : [112.070696, 29.752075],
                mapStyle: "amap://styles/blue",
                viewMode: "3D",
            });
            aMapContainerRef.current = dom;
            aMapTypeRef.current = AMap;
            amapRef.current = amap;

            let marker = new AMap.Marker({
                position: [props.lng, props.lat],
                content: StringUtils.nonull(props.status).toUpperCase() == 'ONLINE' ? `<div class="online-circle">
                    <div class="waves" style="animation: wave ease-out infinite 2s 0s"></div>
                    <div class="waves" style="animation: wave ease-out infinite 2s 0.3s"></div>
                    <div class="waves" style="animation: wave ease-out infinite 2s 0.6s"></div>
                </div>`
                : `<div class="offline-circle"></div>`,
                offset: new AMap.Pixel(-5, -5),
                cursor: 'pointer',
            });
            marker.setMap(amap);
        }).catch((e)=> {
            console.log(e);
        });
    };

    // onload
    useEffect(()=> {
        return ()=> {
            locaContextRef.current?.loca?.destroy();
            amapRef.current?.destroy();
        }
    }, []);

    // render
    return <MapPositionWrapper>
        <div id="map-container" style={{width: "100%", height: "100%"}} ref={(dom)=> initializeMap(dom)}>
        </div>
    </MapPositionWrapper>;
};

export default MapPosition;

